if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.previousButton = this.querySelector('[data-product-modal-previous]');
        this.nextButton = this.querySelector('[data-product-modal-next]');

        this.previousButton?.addEventListener('click', () => this.showAdjacentMedia(-1));
        this.nextButton?.addEventListener('click', () => this.showAdjacentMedia(1));

        /*
         * ModalDialog closes a media modal on mouse pointer-up.
         * Stop navigation-button events from reaching that global handler.
         */
        this.querySelectorAll('[data-product-modal-nav]').forEach((button) => {
          button.addEventListener('pointerup', (event) => event.stopPropagation());
        });

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.showAdjacentMedia(-1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.showAdjacentMedia(1);
          }
        });
      }

      show(opener) {
        super.show(opener);
        this.showMediaById(opener.getAttribute('data-media-id'));
      }

      getMediaItems() {
        const content = this.querySelector('.product-media-modal__content');

        return Array.from(content.children).filter(
          (element) =>
            element.hasAttribute('data-media-id') &&
            !element.classList.contains('product__media-item--variant')
        );
      }

      getActiveMedia() {
        return this.querySelector('.product-media-modal__content > [data-media-id].active');
      }

      showMediaById(mediaId) {
        let mediaItems = this.getMediaItems();
        let activeMedia = mediaItems.find((element) => element.getAttribute('data-media-id') === mediaId);

        /*
         * The selected variant image can carry the variant class.
         * Include it when it is the image used to open the modal.
         */
        if (!activeMedia) {
          activeMedia = this.querySelector(
            `.product-media-modal__content > [data-media-id="${CSS.escape(mediaId)}"]`
          );

          if (activeMedia) mediaItems = [activeMedia, ...mediaItems.filter((item) => item !== activeMedia)];
        }

        if (!activeMedia) return;

        this.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach((element) => {
          element.classList.toggle('active', element === activeMedia);
        });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }

        this.updateNavigation(mediaItems, activeMedia);
      }

      showAdjacentMedia(direction) {
        const activeMedia = this.getActiveMedia();
        if (!activeMedia) return;

        let mediaItems = this.getMediaItems();

        if (!mediaItems.includes(activeMedia)) {
          mediaItems = [activeMedia, ...mediaItems];
        }

        if (mediaItems.length < 2) return;

        const currentIndex = mediaItems.indexOf(activeMedia);
        const nextIndex = (currentIndex + direction + mediaItems.length) % mediaItems.length;

        this.showMediaById(mediaItems[nextIndex].getAttribute('data-media-id'));
      }

      updateNavigation(mediaItems, activeMedia) {
        const hasMultipleMedia = mediaItems.length > 1;

        if (this.previousButton) {
          this.previousButton.hidden = !hasMultipleMedia;
        }

        if (this.nextButton) {
          this.nextButton.hidden = !hasMultipleMedia;
        }

        activeMedia.focus?.({ preventScroll: true });
      }
    }
  );
}